export const ESTADOS_DOCUMENTO_INSCRIPCION = {
  VIGENTE: 'vigente',
  CADUCADO: 'caducado',
};

export const ESTADOS_REVISION_DOCUMENTO_INSCRIPCION = {
  PENDIENTE: 'pendiente',
  APROBADO: 'aprobado',
  RECHAZADO: 'rechazado',
};
